import { render, staticRenderFns } from "./SJanela.vue?vue&type=template&id=b662be48"
import script from "./SJanela.vue?vue&type=script&lang=js"
export * from "./SJanela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports